import Vue from 'vue'
import {
  Spin,
  Icon,
  Popover,
  Modal,
  Tooltip,
  message,
} from 'ant-design-vue'

Vue.use(Spin)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(Modal)
Vue.use(Tooltip)

Vue.prototype.$message = message
